import { useContext } from 'react'
import { ArtStatusService, OrchestratorImageGenerationService, OrchestratorTextGenerationService, UserAccountsService } from '../services'
import { ArtPedingContext } from '../contexts/ArtPendingContext/ArtPendingContext'

export const UseGenerateArt = () => {
  const {setArtStatus, artStatus, setShowSnackBar} = useContext(ArtPedingContext)

  const handleStartImageGeneration = async (body, requestConfig = {}) => {
    setShowSnackBar(true)
    const userAccount = await UserAccountsService.getUserAccountsByLogin()
    const userAccountId = userAccount?.data?.uuid
    const response  = await OrchestratorImageGenerationService.generateArt({userAccountId:userAccountId, ...body}, requestConfig)

    if (!response?.aborted && response?.data?.artStatusId) {
      setArtStatus({status:'PENDING', uuid:response?.data?.artStatusId, imageUrl:'', isVisualized:false})
    }

    return response
  }

  const handleStartReferenceImageGeneration = async (body, requestConfig = {}) => {
    setShowSnackBar(true)
    const userAccount = await UserAccountsService.getUserAccountsByLogin()
    const userAccountId = userAccount?.data?.uuid
    const response  = await OrchestratorImageGenerationService.generateArtWithReference({userAccountId:userAccountId, ...body}, requestConfig)

    if (!response?.aborted && response?.data?.artStatusId) {
      setArtStatus({status:'PENDING', uuid:response?.data?.artStatusId, imageUrl:'', isVisualized:false})
    }

    return response
  }

  const handleEditImageGeneration = async (body, requestConfig = {}) => {
    setShowSnackBar(true)
    const response  = await OrchestratorImageGenerationService.editArt(artStatus.uuid, body, requestConfig)

    if (!response?.aborted && response?.data?.artStatusId) {
      setArtStatus({status:'PENDING', uuid:response?.data?.artStatusId, imageUrl:'', isVisualized:false})
    }

    return response
  }

  const handleEditImageGenerationWithReference = async (body, requestConfig = {}) => {
    setShowSnackBar(true)
    const response  = await OrchestratorImageGenerationService.editArtWithReference(body, requestConfig)

    if (!response?.aborted && response?.data?.artStatusId) {
      setArtStatus({status:'PENDING', uuid:response?.data?.artStatusId, imageUrl:'', isVisualized:false})
    }

    return response
  }

  // refaz a request reenviando a legenda para que ela nao seja gerada novamente
  const handleRegenerateReferenceImage = async (body, requestConfig = {}) =>{
    setShowSnackBar(true)
    const userAccount = await UserAccountsService.getUserAccountsByLogin()
    const userAccountId = userAccount?.data?.uuid
    const response  = await OrchestratorImageGenerationService.generateArtWithReference({userAccountId:userAccountId, ...body, generateLegend:true}, requestConfig)

    if (!response?.aborted && response?.data?.artStatusId) {
      setArtStatus({status:'PENDING', uuid:response?.data?.artStatusId, imageUrl:'', isVisualized:false})
    }

    return response
  }

  const handleGenerateLegend = async (body) => {
    const legendGenerated = await OrchestratorTextGenerationService.generateLegend(body)
    const rawLegend = legendGenerated?.data?.text || ''
    let legend = rawLegend
    try {
      const parsed = JSON.parse(rawLegend)
      if (parsed && typeof parsed.legenda === 'string') {
        legend = parsed.legenda
      }
    } catch {
      // não é JSON, manter texto puro
    }
    return legend
  }

  // const checkImageGenerationStatus = async (uuid) => {
  //   const response = await OrchestratorImageGenerationService.checkArtStatus(uuid)

  //   if(!response?.data?.isVisualized){
  //     setArtStatus((prev)=>({...prev, ...response?.data}))
  //   }

  //   if(!response?.data?.isVisualized && response.data.status === 'ERROR'){
      
  //     if(response.data.description === 'unsafe_prompt'){
  //       notifyErrorCustom('Erro ao gerar prompt: o prompt viola as políticas de privacidade')
  //     }


  //     if(response?.data?.isVisualized ) setArtStatus((prev)=>({...prev, status:'PENDING', imageUrl:''}))
  //   } 

  // }

  const checkUserHasArtPending = async () => {
    const userAccount = await UserAccountsService.getUserAccountsByLogin()
    const userAccountId = userAccount?.data?.uuid
    const artStatusAlreadyExistsResponse = await ArtStatusService.getArtStatusByUserAccount(userAccountId)
    
    if(!artStatusAlreadyExistsResponse?.data?.isVisualized){
      setArtStatus(artStatusAlreadyExistsResponse?.data)
    }

    if(artStatusAlreadyExistsResponse?.data === null){
      return false
    }

    return !artStatusAlreadyExistsResponse?.data?.isVisualized
  }


  const handleUpdateArtStatusOnImageVisualization = async() => {
    await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
  }

  // useEffect(() => { 
 
  //   let interval
  //   if(artStatus?.status === 'PENDING' && artStatus?.uuid) {
  //     interval = setInterval(async () => await checkImageGenerationStatus(artStatus?.uuid), 10000);
  //   } else {
  //     handleUpdateArtStatusOnImageVisualization();
  //   }
  //   return ()=> clearInterval(interval)
  // }, [artStatus])
  
  const handleApplyShamanSeal = async (body, requestConfig = {}) => {
    setShowSnackBar(true)
    const response = await OrchestratorImageGenerationService.applyShamanSeal(artStatus.uuid, body, requestConfig)

    if (!response?.aborted && response?.data?.artStatusId) {
      const imageUrl = response.data.url
      const separator = imageUrl.includes('?') ? '&' : '?'
      const cacheBustedUrl = imageUrl ? `${imageUrl}${separator}t=${Date.now()}` : ''

      setArtStatus((prev) => ({ 
        ...prev,
        status: 'DONE', 
        uuid: response.data.artStatusId, 
        imageUrl: cacheBustedUrl, 
        isVisualized: false 
      }))
    }

    return response
  }

  const handleDeleteWhenVisualized = async () => {
    await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
    setArtStatus((prev) => ({ ...prev, isVisualized: true }))
  }

  return {
    artStatus,
    setArtStatus,
    setShowSnackBar,
    handleStartImageGeneration,
    handleStartReferenceImageGeneration,
    handleRegenerateReferenceImage,
    handleEditImageGenerationWithReference,
    handleEditImageGeneration,
    handleApplyShamanSeal,
    handleGenerateLegend,
    handleUpdateArtStatusOnImageVisualization,
    handleDeleteWhenVisualized,
    checkUserHasArtPending
  }
}